import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { operatorsApi, type CreateOperatorBody, type UpdateOperatorBody } from '@/api/operators.api';
import toast from 'react-hot-toast';

export function useOperators() {
  return useQuery({
    queryKey: ['operators'],
    queryFn: () => operatorsApi.list(),
  });
}

export function useCreateOperator() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateOperatorBody) => operatorsApi.create(body),
    onSuccess: () => {
      toast.success('Operador creado');
      qc.invalidateQueries({ queryKey: ['operators'] });
    },
    onError: (err: Error) => toast.error(err.message || 'Error al crear'),
  });
}

export function useUpdateOperator() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: UpdateOperatorBody }) => operatorsApi.update(id, body),
    onSuccess: () => {
      toast.success('Operador actualizado');
      qc.invalidateQueries({ queryKey: ['operators'] });
    },
    onError: (err: Error) => toast.error(err.message || 'Error al actualizar'),
  });
}

export function useDeleteOperator() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => operatorsApi.remove(id),
    onSuccess: () => {
      toast.success('Operador eliminado');
      qc.invalidateQueries({ queryKey: ['operators'] });
    },
    onError: (err: Error) => toast.error(err.message || 'Error al eliminar'),
  });
}
